import { AmdbAccessCheckerService } from '@amdb/drone/@core/security/amdb-access-checker.service';
import { AmdbLoginService } from '@amdb/drone/auth/amdb-login-token/amdb-login.service';
import { AuthorizeOnBehalfService } from '@amdb/drone/auth/authorize-on-behalf/authorize-on-behalf.service';
import { Authority } from '@amdb/drone/shared/models';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NbTokenService } from '@nebular/auth';
import { NbToastrService } from '@nebular/theme';
import { lastValueFrom, map, Observable, of } from 'rxjs';

@Component({
    selector: 'amdb-authorize-on-behalf-of-header',
    templateUrl: './authorize-on-behalf-of-header.component.html',
    styleUrls: ['./authorize-on-behalf-of-header.component.scss'],
})
export class AuthorizeOnBehalfOfHeaderComponent implements OnInit {
    selectedAuthority: Authority;
    authorities: Authority[] = [];
    filteredAuthorities$: Observable<Authority[]>;

    constructor(
        private authorizeOnBehalfService: AuthorizeOnBehalfService,
        private tokenService: NbTokenService,
        private accessCheckerService: AmdbAccessCheckerService,
        private loginService: AmdbLoginService,
        private toastrService: NbToastrService,
    ) {}

    async ngOnInit(): Promise<void> {
        const selectedAuthorityId: number = Number(this.accessCheckerService.getAuthorityId((await lastValueFrom(this.tokenService.get())).getPayload()));
        this.authorities = await this.authorizeOnBehalfService.getAuthorizableAuthorities();
        this.selectedAuthority = this.authorities.find((authority: Authority): boolean => authority.id === selectedAuthorityId);
        this.filteredAuthorities$ = of(this.authorities);
    }

    onAuthoritySelectSearchChange(value: string): void {
        this.filteredAuthorities$ = this.getFilteredOptions(value);
    }

    async onSelectedAuthorityChanged(authority: Authority): Promise<void> {
        try {
            const authResult = await this.authorizeOnBehalfService.authorizeOnBehalfOf(authority.id);
            this.loginService.processSocialAuthResult(authResult);
            setTimeout(() => {
                window.location.href = '/#/user-profile';
            }, 100);
        } catch (errorResponse) {
            if (errorResponse instanceof HttpErrorResponse) {
                this.toastrService.danger(errorResponse.error.errors, 'Kļūda');
            }
        }
    }

    getFilteredOptions(value: string): Observable<Authority[]> {
        return of(value).pipe(map((filterString: string): Authority[] => this.filter(filterString)));
    }

    authorityDisplayFn(authority: Authority | string): string {
        if (!authority) {
            return '';
        }

        // user typing
        if (typeof authority === 'string') {
            return authority;
        }

        // selected object
        return `${authority.name} (${authority.role})`;
    }

    private filter(value: string): Authority[] {
        const filterValue: string = value.toLowerCase();
        return this.authorities.filter((optionValue: Authority): boolean => optionValue.name.toLowerCase().includes(filterValue));
    }
}
